<template>
  <div>
    <card title="Contratos para alterar o ponto manualmente" subTitle="Contratos falhos ao alterar status do ponto no gerenet">
      <div slot="raw-content" class="table-responsive">
        <table class="table table-striped">
          <thead>
            <th>ID Contrato</th>
            <th>Nome Contrato</th>
            <th>ID Cliente</th>
            <th>ID Ponto</th>
            <th>Status Ponto</th>
            <th>Trocar para</th>
            <th>Assinado</th>
            <th>Ações</th>
          </thead>
          <tbody>
            <tr v-for="contract in contracts" :key="contract.id">
              <td>{{ contract.id }}</td>
              <td>{{ contract.name }}</td>
              <td>{{ contract.clientId }}</td>
              <td>{{ contract.pointId }}</td>
              <td>{{ contract.isNew ? 'Novo' : 'Existente' }}</td>
              <td>{{ contract.isNew ? 'Primeira Conexão' : 'Ativo' }}</td>
              <td>{{ formatDate(contract.signedAt) }}</td>
              <td @click="updateStatus(contract.id)">
                <p-button
                  type="success"
                  outline
                  icon
                  title="Marcar como atualizado"
                >
                  <i class="fa fa-check"></i>
                </p-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </card>
  </div>
</template>

<script>
import { formatDistance } from "date-fns";
import pt from "date-fns/locale/pt-BR";
import Swal from "sweetalert2";
import { mapActions } from "vuex";

export default {
  computed: {
    contracts() {
      return this.$store.getters.failedContracts;
    }
  },
  methods: {
    ...mapActions(["fetchFailedContracts", "updatecontract"]),
    formatDate(date) {
      return formatDistance(new Date(date), new Date(), {
        locale: pt,
        addSuffix: true,
      });
    },
    async updateStatus(id) {
      const result = await Swal.fire({
        title: "Atenção!",
        text:
          "Esta ação irá marcar o contrato como atualizado, deseja prosseguir?",
        icon: "warning",
        focusConfirm: false,
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#9dcf6b",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      });

      if (result.isConfirmed) {
        try {
          await this.updatecontract({ id });
          Swal.fire({
            title: "Sucesso!",
            text: "Contrato atualizado com sucesso",
            icon: "success"
          });
        } catch (e) {
          Swal.fire({
            title: "Ops!",
            text: "Não foi possível atualizar o contrato",
            icon: "error"
          });
        }
      }
    }
  },
  async mounted() {
    await this.fetchFailedContracts();
  }
};
</script>

<style scoped>
td i:hover {
  color: green;
}
</style>